module.exports = __webpack_public_path__ + "static/media/DSC04661.cb439882.JPG";